import { render, staticRenderFns } from "./PurplePlusIcon.vue?vue&type=template&id=164b0696"
import script from "./PurplePlusIcon.vue?vue&type=script&lang=js"
export * from "./PurplePlusIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports